import { getAuthToken, isLoggedIn } from "@/utils/authUtil";
import { getRouteByPerfilNumber, ROTA_BASE, ROTA_PADRAO, ROTAS_TRAVADAS } from "@/utils/perfilRouteUtil";

import store from "@/store";

const hasAccessPermition = async to => {
  if (to.meta.allowAnonymous) return true;
  if (to.meta.checkPathDisabled) return true;

  // Verifica se o usuário tem menu exclusivo e está tentando acessar a rota /carta
  if (
    (to.path === "/carta" || to.path === "/seguro-viagem/carta") &&
    store.getters["saude/hasExclusiveTravelInsurance"]
  ) {
    return false;
  }

  const menu = store.state.saude.menu ?? [];
  let toPath = to.path;
  if (toPath.includes("?")) {
    toPath = toPath.substring(0, toPath.indexOf("?"));
  }
  if (toPath.endsWith("/")) {
    toPath = toPath.substring(0, toPath.length - 1);
  }
  const validPath = to.meta.validPath?.length ? to.meta.validPath : [toPath];
  let valid = !!validPath.find(p => !!menu.find(m => m.View && m.View.startsWith(p)));
  if (!valid) {
    const menusFavoritos = store.state.saude.menusFavoritos ?? [];
    valid = !!validPath.find(p => !!menusFavoritos.find(m => m.View && m.View.startsWith(p)));
  }
  if (valid && to.meta.validAction) {
    valid = await store.dispatch(to.meta.validAction);
  }
  return valid;
};

async function beforeEachRouteGuard(to, from, next) {
  if (to.path === "/carta-permanencia") {
    const isEnabled = process.env.VUE_APP_ENABLE_CARTA_PERMANENCIA === "true";
    if (!isEnabled) {
      next(ROTA_BASE);
      return;
    }
  }

  if (!to.meta.offline && !navigator.onLine) {
    // rota permite apenas navegação online e está sem conexão com a internet
    window.dispatchEvent(new Event("offline"));
    next(false);
    return;
  }

  if (to.name === "logout") {
    // sem regra para sair da aplicação
    next();
    return;
  }

  const appLocked = store.state.accessManagement.appLocked;
  if (to.name === "login" && appLocked) {
    next();
    return;
  }

  const vinculo = store.state.saude.vinculo;
  const operacao = store.state.saude.operacao;
  const perfil = store.state.saude.perfil;
  const routeByPerfil = operacao > 0 && perfil > 0 ? getRouteByPerfilNumber(operacao, perfil) : "";
  if (to.name === "login" && isLoggedIn(true)) {
    // login foi realizado (existe token de autenticação)
    if (vinculo === "" || perfil === 0 || operacao === 0) {
      // vinculo não foi selecionado, solicitado novo login
      next();
    } else {
      // autenticação realizada e vinculo do associado foi selecionado
      next({ path: routeByPerfil });
    }
    return;
  }

  const isLogged = isLoggedIn();
  if (isLogged && to.name === "vinculos" && (vinculo === "" || perfil === 0 || operacao === 0)) {
    next();
    return;
  }

  if (
    to.name !== "redirect" &&
    to.name !== "readonly.access" &&
    ((to.query.vinculo && to.query.login && to.query.usuario) || (to.query.cd1 && to.query.cd2 && to.query.cd4))
  ) {
    await store.dispatch("logoutUser");
    const authQuery = {
      nextUrl: to.path
    };
    Object.keys(to.query).map(k => {
      authQuery[k] = to.query[k];
    });
    next({
      name: "redirect",
      params: authQuery
    });
    return;
  }

  if (!to.meta.allowAnonymous && (!isLogged || vinculo === "" || perfil === 0 || operacao === 0)) {
    // será solicitada a autenticação se página de destino será exibida após o login
    if (to.fullPath === "" || to.fullPath === "/" || to.fullPath === "/vinculos" || to.fullPath === routeByPerfil) {
      next({
        path: ROTA_PADRAO
      });
    } else {
      next({
        path: ROTA_PADRAO,
        query: {
          nextUrl: to.fullPath
        }
      });
    }
    return;
  }

  if (isLogged) {
    if (!window.$axios.hasAuthToken()) {
      window.$axios.setAuthToken(getAuthToken());
    }
    if (!store.state.saude.hydrated && !store.state.saude.hydrating) {
      await store.dispatch("saude/hydrate");
    }
    const sessaoValida = await store.dispatch("myAccount/sessionState");
    if (sessaoValida && to.name !== "logout") {
      for (const rota_travada of ROTAS_TRAVADAS(store.state)) {
        if ((rota_travada.path === "/inadimplencia" && to.path === "/faturas") || to.path.includes("biometry")) {
          // Permitir acesso à rota de faturas mesmo com a rota de inadimplência travada
          break;
        }
        if (rota_travada.condiction) {
          if (to.path.includes(rota_travada.path)) break;
          next({
            path: rota_travada.path,
            query: rota_travada.nextPath
              ? {
                  nextUrl: to.fullPath
                }
              : undefined
          });
        }
      }

      const hasPermition = await hasAccessPermition(to);
      if (!hasPermition) {
        const initRoute = await store.dispatch("saude/fetchInitRoute");
        if (from?.path && from.path.startsWith(initRoute)) {
          next(ROTA_BASE);
        } else {
          next(initRoute);
        }
        return;
      }

      const registroNavegacao =
        vinculo !== "" &&
        to?.name &&
        from?.name &&
        (from.fullPath === "/" ||
          from.fullPath === routeByPerfil ||
          (to.name.indexOf(from.name) < 0 && from.name.indexOf(to.name) < 0));
      if (registroNavegacao) {
        if (to.meta?.registerAccess?.servico && to.meta?.registerAccess?.funcionalidade) {
          // registra acesso usuario (independente de idClassifica)
          store.dispatch("myAccount/registerAccess", {
            servico: to.meta.registerAccess.servico,
            funcionalidade: to.meta.registerAccess.funcionalidade,
            id: null
          });
        }
        if (to.meta?.idClassifica) {
          // registro de chamado de navegação
          // apenas para usuários autenticados e com vínculo selecionado
          // apenas rotas com classificação de rastreio (idClassifica)
          store.dispatch("myAccount/registerNavigation", {
            classificacao: to.meta?.idClassifica
          });
        }
      }
      next();
    } else {
      next("/logout");
    }
  } else {
    next();
  }
}

export default beforeEachRouteGuard;
